export default __webpack_public_path__ + "static/media/timeframe_finished_background.c835a74e.svg";